/**
 * Development-only logging. In production builds, no-op.
 * Use for diagnostic logs; keep console.error and console.warn for real problems.
 */
const isDev =
  typeof process !== 'undefined' &&
  process.env?.NODE_ENV === 'development';

export function debugLog(...args) {
  if (isDev) {
    console.log(...args);
  }
}

export function debugDebug(...args) {
  if (isDev && typeof console.debug === 'function') {
    console.debug(...args);
  }
}
